import { log } from '../helpers';
import { state } from '../core';
import { Actions } from '../resources';
import { renderButton, renderListPage, renderModal } from '../components';

/**
 * Dispatch a custom event
 * @param  {*}      detail Any details to pass along with the event
 */

const storeInstance = {
  stored: { state },

  set state(newState) {
    this.stored = { state: newState };
    document.dispatchEvent(
      new CustomEvent(Actions.UPDATE_STORE, {
        bubbles: true,
        cancelable: true,
        detail: newState,
      })
    );
  },
  get state() {
    return this.stored.state;
  },
};

// copy/merge to new state
export const setState = (payload: Partial<StateType>) => {
  log('setState', payload);
  const newState = { ...storeInstance.state, ...payload };
  storeInstance.state = newState;
};

//components "subscribing to store" here
export const renderAll = (firstRender = false) => {
  const { pageType } = getState();

  if (pageType === 'article') {
    renderButton(firstRender);
    renderModal();
  }
  if (pageType === 'list') {
    renderListPage(firstRender);
  }
};

export const getState = () => storeInstance.state;
